import React from 'react';
import Loadable from 'react-loadable';

import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Mcp2019Component = false;
let Mcp2018Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Mcp2019Component = require('./most_creative_people_2019_page').default;
  // eslint-disable-next-line global-require
  Mcp2018Component = require('./most_creative_people_2018_page').default;
}

export function mcp2019Page(store) {
  const routeConfig = {
    path: '/most-creative-people/2019',
    component() {
      if (Mcp2019Component) {
        return <Mcp2019Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Mcp2019Component
      ? Mcp2019Component.loadData(store, '2019')
      : false,
    preloadChunk() {
      return import(/* webpackChunkName: "mcp2019Page" */ './most_creative_people_2019_page').then(
        resp => {
          Mcp2019Component = resp.default;
          routeConfig.loadData = Mcp2019Component.loadData(store);
          return Mcp2019Component;
        }
      );
    },
    chunk: 'mcp2019Page'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function mcp2018Page(store) {
  const routeConfig = {
    path: '/most-creative-people/2018',
    component() {
      if (Mcp2018Component) {
        return <Mcp2018Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Mcp2018Component
      ? Mcp2018Component.loadData(store, '2018')
      : false,
    preloadChunk() {
      return import(/* webpackChunkName: "Mcp2018Page" */ './most_creative_people_2018_page').then(
        resp => {
          Mcp2018Component = resp.default;
          routeConfig.loadData = Mcp2018Component.loadData(store);
          return Mcp2018Component;
        }
      );
    },
    chunk: 'mcp2018Page'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let LegacyComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  LegacyComponent = require('./most_creative_people_page').default;
}

export function legacyMcpPage(store) {
  const routeConfig = {
    path:
      '/most-creative-people/:year(2009|2010|2011|2012|2013|2014|2015|2016|2017)',
    component() {
      if (LegacyComponent) {
        return <LegacyComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: LegacyComponent ? LegacyComponent.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "legacyMcpPage" */ './most_creative_people_page').then(
        resp => {
          LegacyComponent = resp.default;
          routeConfig.loadData = LegacyComponent.loadData(store);
          return LegacyComponent;
        }
      );
    },
    chunk: 'legacyMcpPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let DefaultComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  DefaultComponent = require('./most_creative_people_future_page').default;
}

export function defaultMcpPage(store) {
  const routeConfig = {
    path: '/most-creative-people/:year',
    component() {
      if (DefaultComponent) {
        return <DefaultComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: DefaultComponent ? DefaultComponent.loadData(store) : false,
    preloadChunk() {
      return import('./most_creative_people_future_page').then(resp => {
        DefaultComponent = resp.default;
        routeConfig.loadData = DefaultComponent.loadData(store);
        return DefaultComponent;
      });
    },
    chunk: 'defaultMcpPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
